import { createStore } from 'vuex'
import accessories from './modules/accessories'
import controlCodes from './modules/controlCodes'
import viewmodels from './modules/viewmodels'
import quote from './modules/quote'
import changeOrder from './modules/changeOrder'
import bulkChangeOrder from './modules/bulkChangeOrder'
import purchaseOrder from './modules/purchaseOrder'
import customer from './modules/customer'
import configuration from './modules/configuration'
import stockcars from './modules/stockcars'
import companies from './modules/companies'
import customerTypes from './modules/customerTypes'
import quotes from './modules/quotes'
import establishments from './modules/establishments'
import user from './modules/user'
import configurationExtended from './modules/configurationExtended'
import dictionary from './modules/dictionary'
import warningBanner from './modules/warningBanner'
import changeOrders from './modules/changeOrders'
import authorization from './modules/authorization'
import stockcarsNew from '@/store/modules/stockcarsNew'
import managerApproval from './modules/managerApproval'
import ui from './modules/ui'

const store = createStore({
  modules: {
    accessories,
    viewmodels,
    quote,
    changeOrder,
    bulkChangeOrder,
    purchaseOrder,
    configuration,
    controlCodes,
    customer,
    stockcars,
    stockcarsNew,
    companies,
    customerTypes,
    quotes,
    establishments,
    user,
    configurationExtended,
    dictionary,
    warningBanner,
    changeOrders,
    authorization,
    managerApproval,
    ui,
  },
})

export default store
